<div [class.print-hidden]="isPrintEnable">
  <eds-panel theme="dark" [edsSpacing]="'none'">
    <div edsGrid>
      <!-- breadcrumbs  area -->
      <eds-breadcrumbs [items]="breadcrumbItems" theme="dark">
      </eds-breadcrumbs>
    </div>
  </eds-panel>
  <ft-tax-list-info-filters
    [taxYear]="taxYear"
    [filters]="filters"
    [recordDetails]="recordDetails"
    (filterListing)="onFilterApplied($event)"
    [downloadTypes]="downloadTypesMenu"
    (downloadEvent)="onDownloadAction($event)"
  ></ft-tax-list-info-filters>
  <div edsGrid>
    <div
      class="{{
        (isCardView$ | async) ? 'cards-mobile' : 'container container--wide'
      }}"
    >
      <!-- First row -->
      <div edsRow edsSpacing="md">
        <div edsCol [columnNumbers]="proximalTopColumnNumbers">
          <eds-proximal
            edsSpacing="lg"
            [placement]="'USTaxInfoPageTop'"
          ></eds-proximal>
        </div>
        <div
          edsCol
          [columnNumbers]="{ s: '4', m: '8', l: '3' }"
          [alignText]="(isHandheld$ | async) ? 'left' : 'right'"
          *ngIf="showFavoritesOnlySwitch"
        >
          <!-- Favorites only switch button -->
          <span>{{ "products.show-favorites-toggle" | translate }}</span>
          <eds-switch
            [switchId]="'favoritesOnlySwitch'"
            [disabled]="false"
            [label]="'products.show-favorites-toggle' | translate"
            [labelOff]="'products.off' | translate"
            [labelOn]="'products.on' | translate"
            [state]="favoritesOnlySwitchState"
            (switchPressed)="onFavoritesOnlyToggle($event)"
            ariaLabelledbyStr="favoritesOnlySwitchLabel"
            labelId="favoritesOnlySwitchLabel"
          ></eds-switch>
        </div>
      </div>

      <!-- Listing section -->
      <div edsRow>
        <div edsCol>
          <eds-dynamic-table
            *ngIf="isPopulated"
            [colDefs]="colDefs"
            idCol="fundShareClassId"
            [rowTemplate]="customTaxInfoRowTemplate"
            [mobileTemplate]="customTaxInfoRowTemplate"
            [rowData]="currentPage$ | async"
            [showPagination]="true"
            tableTheme="secondary"
            padding="md"
            [pageSize]="25"
            [pageSizeOptions]="[25, 50, 75, 100]"
            [cardBreakpoint]="FrkBreakpoint.Tablet"
            [hasCheckboxColumn]="true"
            [hasStickyHeader]="true"
            [hasBorders]="true"
            [labelNoMatchingData]="
              'products.us-tax-info-page-no-filter-result-message' | translate
            "
            [labelDropdown]="'products.items-per-page' | translate"
            [labelDropdownAria]="'products.items-per-page' | translate"
            [labelToggleAllCheckboxes]="
              'products.us-tax-info-page-select-all-group-header-input-label'
                | translate
            "
            [sortAccessibilityText]="'common.sortAccessibilityText' | translate"
            [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
            [sortAriaLiveText]="'common.sortAriaLiveText' | translate"
            [pageTransitionAriaLiveText]="
              'common.pageTransitionAriaLiveText' | translate
            "
            (checkboxChanged)="onChangeSelection($event)"
          ></eds-dynamic-table>
          <!-- custom template used for generating table rows -->
          <ng-template
            let-item
            let-callback="checkboxCallback"
            #customTaxInfoRowTemplate
          >
            <ft-tax-info-row
              [taxInfoItem]="item"
              (checkboxToggled)="callback(item, $event)"
              (print)="print(printType.SINGLE, $event)"
              [expandAll]="expandAll"
            ></ft-tax-info-row>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <eds-sticky-footer
    [itemCount]="rowCountValue"
    [isHide]="rowCount === 0"
    variation="2"
    [primaryAction]="downloadStickyButton"
    [secondaryAction]="printStickyButton"
    (btnSubscribePrimary)="onDownloadAction(downloadType.SELECTED)"
    (btnSubscribeSecond)="print(printType.SELECTED)"
    [stickyFooterName]="'us_taxinfo_sticky_footer'"
  ></eds-sticky-footer>
</div>
<div *ngIf="isPrintEnable">
  <ft-tax-list-info-print
    [printableRecords]="printableRecords"
    [printWindow]="isPrintEnable"
  ></ft-tax-list-info-print>
</div>
